export enum LoginSessionKey {
  LOGIN_PARAM = 'systech_ota_login',
  UNION_ID = 'systech_ota_login_union_id',
  /** nexus 跳板：v1 静默 demo 登录后写入的凭据，web-v2 守卫读取后恢复会话 */
  NEXUS_BRIDGE = 'systech_ota_nexus_bridge',
  /** nexus 跳转到 web-v2 时携带的 union_id（web 写入，web-v2 读取后清除） */
  NEXUS_UNION_ID = 'systech_ota_nexus_union_id',
}
